import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'María G.',
    age: '34 años',
    city: 'Córdoba',
    text: 'Empecé a sublimar hace 6 meses y no sabía qué diseños vender. Con el kit arranqué a vender desde la primera semana. ¡Increíble!',
    initials: 'MG'
  }, {
    name: 'Lucas P.',
    age: '28 años',
    city: 'Rosario',
    text: 'Tenía la máquina parada porque no conseguía diseños buenos. Este kit me cambió el negocio, ahora facturo todos los días.',
    initials: 'LP'
  }, {
    name: 'Valentina R.',
    age: '41 años',
    city: 'Buenos Aires',
    text: 'La variedad es impresionante. Mis clientes siempre encuentran algo que les gusta. Las ventas se triplicaron.',
    initials: 'VR'
  }, {
    name: 'Martín D.',
    age: '35 años',
    city: 'Mendoza',
    text: 'Dejé de perder tiempo buscando imágenes por internet. Todo organizado, listo para imprimir. Lo mejor que compré para mi emprendimiento.',
    initials: 'MD'
  }, {
    name: 'Camila S.',
    age: '26 años',
    city: 'La Plata',
    text: 'Los diseños de anime y Marvel vuelan. Mis clientes me piden más y siempre tengo algo nuevo para ofrecer.',
    initials: 'CS'
  }];
  return <section className="py-14 md:py-16 bg-[#0a0e1a]" data-id="element-183">
      <div className="max-w-[980px] mx-auto px-4" data-id="element-184">
        <motion.h2 initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-[24px] md:text-[32px] font-black text-center mb-12 uppercase text-white" data-id="element-185">
          Testimonios
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-186">
          {testimonials.map((t, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.08
        }} className="glass-card p-5 flex flex-col h-full" data-id="element-187">
              <div className="flex text-[#f5a623] mb-3" data-id="element-188">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-189" />)}
              </div>
              <p className="text-[15px] text-gray-300 italic mb-5 flex-1" data-id="element-190">
                "{t.text}"
              </p>
              <div className="flex items-center space-x-3 mt-auto pt-3 border-t border-white/10" data-id="element-191">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#f5a623] to-[#ef4444] flex items-center justify-center text-white font-bold text-sm" data-id="element-192">
                  {t.initials}
                </div>
                <div data-id="element-193">
                  <h4 className="text-white font-bold text-sm" data-id="element-194">{t.name}</h4>
                  <p className="text-xs text-gray-400" data-id="element-195">
                    {t.age}, {t.city}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}